<template>
    <div class="portfolio" v-if="load">
        <div class="portfolio-image">
            <div class="overlay">
                <navbar />
                <h2 class="main-title">{{ $t('portfolio.main_title') }}</h2>
            </div>
        </div>
        <div class="portfolio-content container">
            <div class="row">
                <div class="col-lg-4">
                    <b-button-group style="margin-top: 25px;">
                        <b-button disabled>
                            <b-icon icon="funnel-fill" style="margin: 0 5px"></b-icon>Filter
                        </b-button>

                        <b-button
                            variant="success"
                            v-if="filter == 'All'"
                            @click="filter = 'All'"
                        >All</b-button>
                        <b-button variant="outline-success" v-else @click="filter = 'All'">All</b-button>

                        <b-button
                            variant="success"
                            v-if="filter == 'Mobile'"
                            @click="filter = 'Mobile'"
                        >Mobile</b-button>
                        <b-button variant="outline-success" v-else @click="filter = 'Mobile'">Mobile</b-button>

                        <b-button
                            variant="success"
                            v-if="filter == 'Web'"
                            @click="filter = 'Web'"
                        >Web</b-button>
                        <b-button variant="outline-success" v-else @click="filter = 'Web'">Web</b-button>
                    </b-button-group>
                </div>
            </div>

            <div
                class="card"
                v-for="(item, index) in filterData"
                :key="index"
                style="background:#efefefa6"
            >
                <div class="row">
                    <div class="col-lg-5 left">
                        <div v-scrollanimation>
                            <div class="container-logo">
                                <img :src="item.logo[0].original_url" width="100" :alt="item.title" />
                            </div>
                            <h3 class="title">{{ item.title }}</h3>
                            <div class="disc">{{ item.description }}</div>
                        </div>
                    </div>
                    <div class="col-lg-1"></div>
                    <div class="col-lg-6 right">
                        <div v-scrollanimation>
                            <img
                                :src="item.image[0].original_url"
                                class="mockup"
                                width="400"
                                :alt="item.name"
                                height="auto"
                            />
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 20px;column-gap: 15px;padding: 0 15px;">
                    <div style="text-align: justify;" v-if="(item.type == 'web' || item.type == 'web&mobile') && (item.web_link != null && item.web_link != '')">
                        <b-button class="portfolio-buttom">
                            <a :href="item.web_link" target="_blabk">
                                <b-icon icon="globe" style="margin: 0 5px"></b-icon>Website
                            </a>
                        </b-button>
                    </div>
                    <div  style="text-align: justify;" v-if="(item.type == 'mobile' || item.type == 'web&mobile') && (item.googleplay_link != null && item.googleplay_link != '')">
                        <b-button class="portfolio-buttom">
                            <a :href="item.googleplay_link" target="_blabk">
                                <b-icon icon="play-fill" style="margin: 0 5px"></b-icon>Google Play
                            </a>
                        </b-button>
                    </div>
                    <div  style="text-align: justify;" v-if="(item.type == 'mobile' || item.type == 'web&mobile') && (item.appstore_link != null && item.appstore_link != '')">
                        <b-button class="portfolio-buttom">
                            <a :href="item.appstore_link" target="_blabk">
                                <!-- <b-icon icon="play" style="margin: 0 5px"></b-icon> -->
                                App Store
                            </a>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <get-project />
        <custom-footer />
    </div>
    <loader3 v-else />
</template>

<script>
import Navbar from "@/components/Navbar.vue"
import CustomFooter from "@/components/CustomFooter.vue"
import Loader3 from "@/components/Loader3.vue"
import GetProject from "@/components/GetProject.vue";
export default {
    name: "Portfolio",
    components: {
        Navbar,
        CustomFooter,
        Loader3,
        GetProject
    },
    data() {
        return {
            data: [],
            load: false,
            project_id: null,
            filter: "All",
            filterData: []
        };
    },
    watch: {
        filter(val) {
            if (val == "Web")
                this.filterData = this.data.filter(item => (item.type == 'web' || item.type == 'web&mobile'))
            if (val == "Mobile")
                this.filterData = this.data.filter(item => (item.type == 'mobile' || item.type == 'web&mobile'))
            if (val == "All")
                this.filterData = this.data
        }

    },
    methods: {
        getPortfolio() {
            this.axios.get(this.$store.state.url + "portfolios")
                .then(res => {
                    this.load = true
                    this.data = res.data.list
                    this.filterData = res.data.list
                });
        },

    },
    mounted() {
        document.documentElement.scrollTop = 0;
        this.getPortfolio()
    },
};
</script>


<style lang="scss">
.portfolio .portfolio-buttom{
    background: var(--main-blue);
    border-radius: 8px;
    transition: all .3s;
}
.portfolio .portfolio-buttom:hover{
    background: var(--main-blue);
    box-shadow: 0 0 10px rgba(128, 128, 128, 0.582);
    transition: all .3s;
}
.portfolio-content a{
    color: unset !important;
}
.portfolio {
    position: absolute;
    z-index: 100;
}

.portfolio .portfolio-image {
    background-image: url(../assets/img/portfolio.webp);
    position: relative;
    height: 80vh;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

.portfolio .overlay {
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #126801b6, #15203bce);
}

.portfolio .portfolio-image .main-title {
    text-align: center;
    font-weight: bold;
    color: #fff;
    margin-bottom: 60px;
    padding-top: 130px;
}

@media (min-width: 992px) {
    .portfolio .portfolio-image .main-title {
        font-size: 50px;
    }
}

@media (max-width: 991px) {
    .portfolio .portfolio-image .main-title {
        font-size: 30px;
    }

    .portfolio .portfolio-image {
        height: 60vh;
    }
}

.portfolio .title {
    font-weight: bold;
    text-align: justify;
    color: var(--main-blue);
    margin-top: 25px;
}

.portfolio .disc {
    text-align: justify;
    margin-top: 25px;
    color: #646464;
}

.portfolio .container-logo {
    text-align: justify;
}

.portfolio .mockup {
    transition: all 0.7s;
}

.portfolio .card {
    margin: 30px;
    padding: 20px 70px;
    border-radius: 20px;
    border: none;
    // background: #bdbdbd1f;
    transition: all 0.7s;
    // height: 500px;
    justify-content: center;
    text-align: center;
}

.portfolio .right {
    display: flex;
    justify-content: center;
    align-items: center;
}

@media (min-width: 992px) {
    .portfolio .card {
        height: 500px;
    }
}

@media (max-width: 991px) {
    .portfolio .card {
        padding: 30px 20px;
        height: auto;
    }

    .portfolio .right {
        margin-top: 30px;
    }
}

.portfolio .card:hover {
    box-shadow: 0 0 20px #00000036;
    transition: all 0.7s;

    // background: #fff;
    .mockup {
        transform: scale(1.1, 1.1);
        transition: all 0.7s;
    }
}

.portfolio .left {
    display: flex;
    align-items: center;
    text-align: justify;
}

html:lang(en) .portfolio .left .before-enter {
    opacity: 0;
    transform: translateX(-50px);
    transition: all 1s ease;
}

html:lang(ar) .portfolio .left .before-enter {
    opacity: 0;
    transform: translateX(50px);
    transition: all 1s ease;
}

html:lang(ar) .portfolio .left .enter,
html:lang(en) .portfolio .left .enter {
    opacity: 1;
    transform: translateX(0px);
}

html:lang(en) .portfolio .right .before-enter {
    opacity: 0;
    transform: translateX(50px);
    transition: all 1s ease;
}

html:lang(ar) .portfolio .right .before-enter {
    opacity: 0;
    transform: translateX(-50px);
    transition: all 1s ease;
}

html:lang(ar) .portfolio .right .enter,
html:lang(en) .portfolio .right .enter {
    opacity: 1;
    transform: translateX(0px);
}
</style>
